import TrackerExpired from "./components/TrackerExpired";
import Tracker from "./views/Tracker";
import NotFound from "./views/NotFound";
import Error from "./views/Error";

export const routes = [
  {
    path: '/',
    component: Tracker,
  },
  {
    path: '/notfound',
    component: NotFound,
  },
  {
    path: '/error',
    component: Error,
  },
  {
    path: '*',
    component: NotFound,
  }
];
